import React, { useState } from 'react';
import './Sidebar.css';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { List, ListItem, ListItemButton, Collapse } from "@mui/material";

const Sidebar = ({ isOpen, toggleSidebar, isMobileView }) => {
    const authCtx = useAuth();
    const isAdmin = authCtx.user.is_admin;

    return (!isMobileView
        ?
        <aside className={`sidebar desktop-view ${isOpen ? 'open' : 'closed'}`}>
            {!isAdmin && <ProfileInfo user={authCtx.user} />}
            <SidebarMenu isMobileView={false} />
        </aside>
        :
        <div className="container-fluid-mobile-view navbar navbar-dark bg-dark">
            <div className={`custom-offcanvas offcanvas offcanvas-end ${isOpen ? 'show' : 'hide'}`} tabIndex="-1" id="offcanvasNavbar">
                <div className="offcanvas-header">
                    <button type="button" onClick={toggleSidebar} className="btn-close" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body">
                    {!isAdmin && <ProfileInfo user={authCtx.user} />}
                    <SidebarMenu isMobileView={true} />
                </div>
            </div>
        </div>
    );
};

const ProfileInfo = ({ user }) => (
    <div className="profile-info">
        <img className='rounded-circle' src={user.logo || 'assets/logo/dummy-profile.png'} alt='Not Found' width="120px" height="115px" />
        <h5>{user.first_name} {user.last_name}</h5>
        <p>{user.designation || 'N/A'}</p>
    </div>
);

const SidebarMenu = (props) => {
    const authCtx = useAuth();
    const isAdmin = authCtx.user.is_admin;

    const location = useLocation();
    const currentPath = location.pathname;

    const [open, setOpen] = useState(false);
    const toggleCollapse = () => setOpen(!open);

    const renderEmployerSubmenu = () => (
        <Collapse in={open} timeout="auto" unmountOnExit>
            <List className="menu-list custom-font" style={{ padding: 0 }}>
                <ListItem className={`ps-5 ${currentPath === '/employer-details' ? 'active-menu-item menu-item' : 'menu-item'}`}>
                    <NavLink to="/employer-details">
                        <img src="/assets/logo/bullet_point.svg" alt="NA" />
                        <span className="menu-item-label">Employer Details</span>
                    </NavLink>
                </ListItem>
                <ListItem className={`ps-5 ${currentPath === '/my-employers' ? 'active-menu-item menu-item' : 'menu-item'}`}>
                    <NavLink to="/my-employers">
                        <img src="/assets/logo/bullet_point.svg" alt="NA" />
                        <span className="menu-item-label">Employee List</span>
                    </NavLink>
                </ListItem>
            </List>
        </Collapse>
    );

    return (
        <nav className='nav-list-container'>
            <List className='menu-list custom-font' style={{ padding: 0 }}>
                {isAdmin && (
                    <>
                        <ListItem disablePadding className={`${currentPath.startsWith('/analytics') ? 'active-menu-item menu-item' : 'menu-item'} my-1`}>
                            <NavLink to="/analytics">
                                <span className="material-icons">equalizer</span>
                                <span className='menu-item-label'>Engagement Analytics</span>
                            </NavLink>
                        </ListItem>
                        <ListItem disablePadding className={`${currentPath.startsWith('/employer') ? 'active-menu-item menu-item' : 'menu-item'}`}>
                            <NavLink to="/employer">
                                <span className="material-icons">apartment</span>
                                <span className='menu-item-label'>Employers</span>
                            </NavLink>
                        </ListItem>
                        <ListItem disablePadding className={`${currentPath === '/my-employers' ? 'active-menu-item menu-item' : 'menu-item'}`}>
                            <NavLink to="/my-employers">
                                <span className="material-icons">badge</span>
                                <span className='menu-item-label'>Employee List</span>
                            </NavLink>
                        </ListItem>
                    </>
                )}

                {!isAdmin && (
                    <>
                        <ListItem disablePadding className={`${currentPath.startsWith('/home') ? 'active-menu-item menu-item' : 'menu-item'} my-1`}>
                            <NavLink to="/home">
                                <span className="material-icons">home</span>
                                <span className='menu-item-label'>Home</span>
                            </NavLink>
                        </ListItem>
                        <ListItem disablePadding className={`${currentPath.startsWith('/analytics') ? 'active-menu-item menu-item' : 'menu-item'} my-1`}>
                            <NavLink to="/analytics">
                                <span className="material-icons">equalizer</span>
                                <span className='menu-item-label'>Engagement Analytics</span>
                            </NavLink>
                        </ListItem>
                        <ListItem className={`${open ? 'active-menu-item menu-item' : 'menu-item'} p-0`}>
                            <ListItemButton onClick={toggleCollapse} style={{ padding: '4px 30px', color: '#515151' }}>
                                <span className="material-icons">apartment</span>
                                <div className="menu-item-label flex-grow-1">My Employer</div>
                                <i className={`bi ${open ? 'bi-chevron-up' : 'bi-chevron-down'} fs-5`}></i>
                            </ListItemButton>
                        </ListItem>
                        {renderEmployerSubmenu()}
                        <ListItem disablePadding className={`${currentPath.startsWith('/plan-overview') ? 'active-menu-item menu-item' : 'menu-item'} my-1`}>
                            <NavLink to="/plan-overview">
                                <img src='/assets/logo/exp_program.svg' alt='NA' />
                                <span className='menu-item-label'>About the EXP Program</span>
                            </NavLink>
                        </ListItem>
                        <ListItem disablePadding className={`${currentPath.startsWith('/help') ? 'active-menu-item menu-item' : 'menu-item'} my-1`}>
                            <NavLink to="/help">
                                <span className="material-icons">help</span>
                                <span className='menu-item-label'>Help</span>
                            </NavLink>
                        </ListItem>
                    </>
                )}

                {props.isMobileView && (
                    <ListItem disablePadding className="menu-item">
                        <NavLink onClick={authCtx.onLogOut} className="logout-btn">
                            <span className='material-icons'>power_settings_new</span>
                            <span className='menu-item-label'>Logout</span>
                        </NavLink>
                    </ListItem>
                )}
            </List>
        </nav>
    );
};

export default Sidebar;
